import { Component, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { FormGroup } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";
import { LoginService } from '../../../services/login/login.service';

@Component({
  selector: 'app-listado',
  templateUrl: './listado.component.html',
  styleUrls: ['./listado.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})

export class ListadoComponent {
  form: FormGroup;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  RepEmpresaSeg: any = [];
  loading: boolean = false;
  displayedColumns: string[] =
    ['Checked', 'Ruc', 'Empresa', 'Direccion', 'Telefono', 'Anexo', 'Movil', 'TipoEmpresa', 'Localidad3', 'Estado'];

  dataSource = new MatTableDataSource(this.RepEmpresaSeg);

  constructor(private securityService: SecurityService,
    private loginService: LoginService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private router: Router) {
    this.ObtenerListaEmpresaSeg();
  }

  ObtenerListaEmpresaSeg() {
    this.loading = true;

    this.securityService.ObtenerListaEmpresaSeg()
      .subscribe(resp => {
        this.RepEmpresaSeg = resp
        this.dataSource = new MatTableDataSource(this.RepEmpresaSeg);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA PROV. NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }


  Parametros(id: string, empresa?: string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('empresa', empresa);
    this.securityService.idEmpresa = id;
    this.router.navigate(['/empresaSeg/parametro'])

  }
}
